import { Form, TextField } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';

const ContactForm: React.FunctionComponent = () => {
  const { formatMessage } = useIntl();
  return (
    <Form.Section label={formatMessage({ id: 'provider.onboarding.form.contact.title' })}>
      <Form.Field
        name="contactPhone"
        label={formatMessage({ id: 'provider.onboarding.form.contact.phone' })}
        required
      >
        <TextField autoComplete="tel" type="tel" />
      </Form.Field>
      <Form.Field
        name="contactEmail"
        label={formatMessage({ id: 'provider.onboarding.form.contact.email' })}
        required
      >
        <TextField type="email" autoComplete="email" />
      </Form.Field>
    </Form.Section>
  );
};

export default ContactForm;
